import { Component, Input, ViewEncapsulation } from '@angular/core';
import {LoginService} from 'app/main/content/login/login.service';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
@Component({
    selector     : 'fuse-navigation',
    templateUrl  : './navigation.component.html',
    styleUrls    : ['./navigation.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class FuseNavigationComponent
{
    @Input() layout = 'vertical';
    @Input() navigation: any;

    constructor( private loginService1: LoginService, private router: Router)
    {

        this.loginService1.checkToken().subscribe(rescat => {
            console.log(rescat);
            if (rescat.response){
              if (rescat.response === 1){
    
    
                
                
            }
            else{
    
              this.router.navigate(['/login']);
            }
          }
            else{
              this.router.navigate(['/login']);
            }
    
          })

    }
}
